<template>
    <layout>
        <MapComponent
            :id="mapId"
            ref="MapComponent"
            :url="url"
            :acl="acl"
            :mapTools="mapTools"
            :moduleCode="moduleCode"
            :showLoadingSpin="false"
            :activeExpandCollapse="activeExpandCollapse"
            :initialCollapsedExpandCollapse="initialCollapsedExpandCollapse"
            :enableLayerSwitcher="enableLayerSwitcher"
            :enableStreetView="enableStreetView"
            :enableBackoffice="enableBackoffice"
            :enableIdentify="enableIdentify"
            :enableScaleLine="enableScaleLine"
            :enableScaleBox="enableScaleBox"
            :enableMousePosition="enableMousePosition"
            :enableMeasure="enableMeasure"
            :enableCatalog="enableCatalog"
            :enableAnnotations="enableAnnotations"
            :enableAttribution="enableAttribution"
        >
        </MapComponent>

        <!-- Paineis -->
        <template v-slot:aside-control>
            <ToolLayers
                :moduleCode="moduleCode"
                :showButtonOnActionMap="false"
            />
            <ToolPrintvisible
                :moduleCode="moduleCode"
                :showButtonOnActionMap="false"
            />
            <ToolRegulations
                :moduleCode="moduleCode"
                :showButtonOnActionMap="false"
            />

            <PanelMapWrapper
                :moduleCode="moduleCode"
                :mapId="mapId"
            />
            <transition name="fade">
                <SearchControl
                    v-if="enableSearch"
                    data-panel="search"
                    :moduleCode="moduleCode"
                    :mapId="mapId"
                    :posBtnMap="mapButtons.search.position"
                    :idxBtnMap="mapButtons.search.order"
                    :showLabelBtnMap="mapButtons.search.showLabel"
                />
            </transition>
        </template>

        <PanelCemetery
            key="cemetery"
            :moduleCode="moduleCode"
        />
        <PanelSector
            key="sector"
            :moduleCode="moduleCode"
        />
        <PanelOccupation
            key="occupation"
            :moduleCode="moduleCode"
        />
        <PanelInterment
            key="interment"
            :moduleCode="moduleCode"
        />
        <PanelDeedOwner
            key="deedowner"
            :moduleCode="moduleCode"
        />
        <PanelDeedOwnerHolder
            key="deedownerholder"
            :moduleCode="moduleCode"
        />
        <PanelEntity
            key="entity"
            :moduleCode="moduleCode"
        />

        <AdvancedSearch
            key="advanced-search"
            :moduleCode="moduleCode"
        />
    </layout>
</template>

<script>
import layout from "../layouts/main.vue";
import ModuleMixin from "../shared/mixins/ModuleMixin";
import StoreMixin from "../shared/mixins/StoreMixin";
import MapModuleMixin from "../shared/mixins/MapModuleMixin";

export default {
    mixins: [ModuleMixin, StoreMixin, MapModuleMixin],
    components: {
        layout,
        MapComponent: () => import(/* webpackChunkName: "map-component" */ "@/components/maps/MapComponent"),
        ToolLayers: () => import(/* webpackChunkName: "tool-layers" */ "@/app/shared/components/maps/tools/layers"),
        ToolPrintvisible: () => import(/* webpackChunkName: "tool-printvisible" */ "@/app/shared/components/maps/tools/printvisible"),
        ToolRegulations: () => import(/* webpackChunkName: "tool-regulations" */ "@/app/shared/components/maps/tools/regulations"),
        SearchControl: () => import(/* webpackChunkName: "cemeteries-searchcontrol" */ "../controls/SearchControl.vue"),
        AdvancedSearch: () => import(/* webpackChunkName: "cemeteries-advancedsearch" */ "../components/search/AdvancedSearch.vue"),

        PanelMapWrapper: () => import(/* webpackChunkName: "cemeteries-panelmapwrapper" */ '../components/Cemetery/PanelMapWrapper.vue'),
        PanelCemetery: () => import(/* webpackChunkName: "cemeteries-panelcemetery" */ '../components/Cemetery/PanelCemetery.vue'),
        PanelSector: () => import(/* webpackChunkName: "cemeteries-panelsector" */ '../components/Cemetery/PanelSector.vue'),
        PanelOccupation: () => import(/* webpackChunkName: "cemeteries-paneloccupation" */ '../components/Cemetery/PanelOccupation.vue'),
        PanelInterment: () => import(/* webpackChunkName: "cemeteries-panelinterment" */ '../components/Cemetery/PanelInterment.vue'),
        PanelDeedOwner: () => import(/* webpackChunkName: "cemeteries-paneldeedowner" */ '../components/Cemetery/PanelDeedOwner.vue'),
        PanelDeedOwnerHolder: () => import(/* webpackChunkName: "cemeteries-paneldeedownerholder" */ '../components/Cemetery/PanelDeedOwnerHolder.vue'),
        PanelEntity: () => import(/* webpackChunkName: "cemeteries-panelentity" */ '../components/Cemetery/PanelEntity.vue'),
        // PanelMapCemeteryList: () => import(/* webpackChunkName: "cemeteries-panelmapcemeterylist" */ '../components/Cemetery/PanelMapCemeteryList.vue'),
    },
    provide: function() {
        return {
            closeAllMapPanel: this.closeAllMapPanel,
        }
    },
    data() {
        return {
            pageID: 'home',
            process: null,
        };
    },
    mounted() {
        if (this.$route.params.process) {
            this.process = this.$route.params.process.trim();
        }
    },
    created() {},
    beforeDestroy() {
        this.closeAllPanels();
    },
    computed: {},
    methods: {
        onMapLoaded: function (data) {
            let process = this.process;
            if (process) {
                this.zoomToFeature("process", process);
            }
            this.process = null;
        },
        zoomToFeature(key, val) {
            let panel = this.panel[key];
            if (panel) {
                let url = panel.search || null;
                if (url) {
                    let _map = this.getMapObject();
                    this.$http
                        .get(url.replace(":process", val))
                        .then(res => {
                            let items = (res.data && res.data.data) || [];
                            if (items.length > 0) {
                                let item = items[0];
                                let itemGeom = item.geojson || item.geom;
                                if (itemGeom) {
                                    let properties = Object.assign({}, item);
                                    delete properties["geom"];
                                    delete properties["geojson"];
                                    let feature = _map.createFeatureFromGeojson({
                                        id: item.id,
                                        geom: itemGeom,
                                        properties: properties
                                    });
                                    if (feature) {
                                        let geom = feature.getGeometry();
                                        geom.scale(1.25);
                                        _map.zoomToExtent(geom.getExtent());
                                        return (geom.getPolygon ? geom.getPolygon(0) : geom).getInteriorPoint().getCoordinates();
                                    }
                                }
                            }
                            return null;
                        })
                        .then(coordinate => {
                            if (coordinate) {
                                setTimeout(() => {
                                    let viewResolution = _map.getOLMapView().getResolution();
                                    let projection = _map.getProjection().getCode();

                                    this.$eventBus.publish(this.moduleCode, "map.identify", {
                                        activeItemId: val,
                                        coordinate: coordinate,
                                        resolution: viewResolution,
                                        projection: projection,
                                        params: {}
                                    });
                                }, 2500); //wait 2.5 seconds
                            }
                        })
                        .catch(error => {
                            this.showHttpError(error);
                        });
                }
            }
        }
    }
};
</script>

<style lang="scss">
.slide_fixed_height .vueperslides__parallax-wrapper {
    padding-bottom: 0%!important;
    height: 224px;
}
</style>
